import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { selectBffBaseUrl } from '../../store/selectors/api-config.selectors';

@Injectable({ providedIn: 'root' })
export class ReconciliationService {
  private basePath$: Observable<string>;
  constructor(
    private translocoService: TranslocoService,
    private http: HttpClient,
    private store: Store,
  ) {
    this.basePath$ = this.store.pipe(
      selectBffBaseUrl,
      map((url) => `${url}/app/account`),
    );
  }

  getStatusTranslations(status: string) {
    const key = `app.reconciliation.${status}`;
    return this.translocoService.translate(key);
  }

  getStatusColor(status: string) {
    const mapColors = {
      active: 'yellow',
      revoked: 'red',
      completed: 'green',
      'entered-in-error': 'red',
    };

    return mapColors[status];
  }

  transferUser(data) {
    const headers = {
      Accept: '*/*',
    };
    return this.basePath$.pipe(
      switchMap((basePath) =>
        this.http.post(`${basePath}/reroutePatient`, data, {
          headers: headers,
        }),
      ),
    );
  }
}
